"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const locale_1 = require("~/services/locale");
const projections_1 = require("~/openlayers/projections");
const settings_1 = require("~/settings");
const GeocoderForm_1 = __importDefault(require("~/view/GeocoderForm"));
const sha1_1 = __importDefault(require("~/utils/sha1"));
const BaseControl_1 = __importDefault(require("./BaseControl"));
require("./Geocoder.scss");
const ga_1 = __importDefault(require("~/services/ga"));
/**
 * Controleur pour opérer des recherches de lieux sur googlemap et manipuler
 * une carte geoportal.
 */
class Geocoder extends BaseControl_1.default {
    /**
     * Met en place le listener sur le formulaire lorsque le Geocoder est
     * intégré à la carte
     */
    draw(px) {
        super.draw(px);
        this.keepEvents(this.div);
        /** Formulaire */
        this.form = new GeocoderForm_1.default();
        this.form.$el.on("submit", () => this.geocodeSubmit());
        var container = $('<div class="form-container"/>').get(0);
        container.appendChild(this.form.$el.get(0));
        this.div.appendChild(container);
        return this.div;
    }
    /**
     * Soumission du formulaire de recherche du lieu pour geocoder.
     */
    geocodeSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            var address = this.form.getAddress();
            if (address === "")
                return;
            var search = address.toLowerCase().replace(/\s/g, ""), salt = "superheros_", hash = (0, sha1_1.default)(salt + search);
            switch (hash.substring(0, 8)) {
                case "6ac6d918":
                    $.ajax("/js/" + hash.substring(8, 16) + ".js");
                    return;
                default:
                    console.log("Geocode", address);
                // On continue
            }
            // Google analytics
            ga_1.default.logEvent("Map:Search");
            const result = yield getService().geocode(address);
            result && this.onGeocodeResult(result);
        });
    }
    onGeocodeResult(center) {
        console.log("Geocode result: " + center);
        center.transform(getService().projection, this.map.getProjectionObject());
        var zoom = this.map.baseLayer.geocoderZoom;
        // On déplace la carte
        this.map.setCenter(center, zoom);
    }
}
exports.default = Geocoder;
Object.defineProperties(Geocoder.prototype, {
    CLASS_NAME: {
        value: "JGN.Control.Geocoder",
    },
});
/**
 * Client pour le service de geocoding googlemap.
 * singleton
 */
class GeocoderService {
    constructor() {
        // Système de projection utilisé par le géocodeur
        this.projection = projections_1.gpsProjection; //4326
    }
    // Geolocalise une adresse
    geocode(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = {
                method: "GET",
            };
            const query = {
                text: address,
                apiKey: settings_1.settings.geoapifyKey,
            };
            try {
                const response = yield fetch("https://api.geoapify.com/v1/geocode/search?" +
                    encodeQueryParams(query), requestOptions);
                if (!response.ok) {
                    console.log(response.json());
                    return;
                }
                const data = yield response.json();
                const result = data.features[0];
                if (!result) {
                    throw new Error("No result");
                }
                const [lon, lat] = result.geometry.coordinates;
                const point = new OpenLayers.LonLat(lon, lat);
                return point;
            }
            catch (error) {
                alert((0, locale_1.t)("geocoder.error") + error);
            }
        });
    }
}
let _service;
function getService() {
    if (!_service) {
        _service = new GeocoderService();
    }
    return _service;
}
function encodeQueryParams(query) {
    return Object.entries(query)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join("&");
}
